import { render, staticRenderFns } from "./popover-user-profile.vue?vue&type=template&id=40fca31c&"
import script from "./popover-user-profile.vue?vue&type=script&lang=js&"
export * from "./popover-user-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports